<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[6, 5, 4, 3, 2]"
		:completed="6"
		/>
		<p>نتیجه ارزیابی</p>
		<btn 
		type="danger" 
		:img="require('../../assets/img/x_white.svg')" 
		style="margin-top: 33px;"
		text="رد شد"
		/>
		<p class="mt-4">
			دوست عزیز پروفایل شما توسط کارشناسان ما رد شد.
			<br>
در صورت تمایل برای پیگیری و بازنگری مجدد مدارک از طریق تماس با پشتیبان میتوانید اقدام کنید.
			<br>
			<br>
			<br>
			<br>
			<br>
			<br>
			<br>
		</p>
	</div>
</template>

<script>
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import btn from "../../UI/button/btn.vue";
	

	export default {
		name: 'wait_signup',
		data(){
			return {
			}
		},
		components: {
			btn,
			multi_step_progress,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){

		},
		methods:{
		}
	}
</script>
<style>

</style>
